export default "__VITE_ASSET__6507246d__"